import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { GetAffiliateCustomerTimelineResponse } from './get-affiliate-customer-timeline.types'

export const getAffiliateCustomerTimeline = async (
  customerId: string,
): Promise<GetAffiliateCustomerTimelineResponse> => {
  const response = await apiClient.get<GetAffiliateCustomerTimelineResponse>(
    `/v1/affiliation/customers/${customerId}/timeline`,
  )
  return response.data
}

/**
 * The history of one referred person. Keyed by customer id and disabled until
 * the modal that shows it is open: the list already carries everything a row
 * needs, so nobody pays for a timeline they never asked to see.
 */
export const useGetAffiliateCustomerTimeline = (
  customerId: string | null,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: ['affiliate-customer-timeline', customerId],
    queryFn: () => getAffiliateCustomerTimeline(customerId!),
    enabled: Boolean(customerId) && (options?.enabled ?? true),
  })
}
